import {
	Button,
	Flex,
	Heading,
	Image,
	Stack,
	Text,
	// useBreakpointValue,
} from "@chakra-ui/react";

export default function Head() {
	return (
		<Stack minH={"60vh"} direction={{ base: "column", md: "row" }} w={"full"}>
			<Flex p={8} flex={1} align={"center"} justify={"space-around"}>
				<Stack spacing={6} w={"full"} maxW={"md"}>
					<Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
						<Text
							as={"span"}
							position={"relative"}
							color={"blue.400"}
							textShadow={"1px 1px 3px gray"}
							_after={{
								content: "''",
								width: "full",
								// height: useBreakpointValue({ base: "15%", md: "20%" }),
								position: "absolute",
								bottom: 1,
								left: 0,
								// bg: "blue.400",
								zIndex: -1,
							}}
						>
							Hi, I am Abhijit
						</Text>
					</Heading>
					<Text fontSize={{ base: "lg", lg: "3xl" }} color={"gray.500"}>
						Full Stack Web Developer
					</Text>
					<Text fontSize={{ base: "md", lg: "lg" }} color={"blue.500"}>
						Email : abhijitaher2022@gmail.com
					</Text>
					<Text fontSize={{ base: "md", lg: "lg" }} color={"blue.500"}>
						Contact : 9588414323
					</Text>
					<Stack direction={{ base: "column", md: "row" }} spacing={4}>
						<Button
							rounded={"full"}
							bg={"blue.400"}
							color={"white"}
							_hover={{
								bg: "blue.500",
							}}
							onClick={() => {
								window.open(
									"https://drive.google.com/file/d/1g0bLI2Wz5yJKGgLOaNcWw89biN-rgBv1/view?usp=sharing",
									"_blank"
								);
							}}
						>
							Resume
						</Button>
					</Stack>
				</Stack>
			</Flex>
			<Flex flex={1}>
				<Image
					align={"center"}
					// px={8}
					// py={4}
					mb={{ lg: 16 }}
					mx={{ sm: "auto" }}
					boxShadow={"2xl"}
					rounded={"full"}
					maxW={"65vh"}
					width="full"
					objectFit={"cover"}
					src={"https://avatars.githubusercontent.com/u/84370735?v=4"}
				/>
			</Flex>
		</Stack>
	);
}
